import { InputSelector } from "../components/InputSelector";

export default {
    init() {
        if (location.pathname.includes('preliminary-organisations')) {
            this.CRUDActions();
            this.copyLink();
            this.sendInviteEmail();
        }
    },

    CRUDActions() {
        $('body').on('click','.create-preliminary-organisation-btn', function() {
            $('#createPreliminaryOrganisationModal').modal('show');
            this.itemSelector = new InputSelector('#createPreliminaryOrganisationModal #user-select');
        });
        $('body').on('click','.edit-preliminary-org', function() {
            const id = $(this).data('id');
            $.ajax({
                type: 'GET',
                url: '/admin/preliminary-organisations/'+id+'/edit',
                success: (response) => {
                    $('#form-container').html(response);
                    this.itemSelector = new InputSelector('#editPreliminaryOrganisationModal #user-select');
                    $('#editPreliminaryOrganisationModal').modal('show');
                }
            });
            // $('#createPreliminaryOrganisationModal').modal('show');
        });
        $('body').on('click','.delete-preliminary-org', function() {
            const id = $(this).data('id');
            $.ajax({
                type: 'GET',
                url: '/admin/preliminary-organisations/'+id+'/delete',
                success: (response) => {
                    $('#form-container').html(response);
                    $('#deletePreliminaryOrganisationModal').modal('show');
                }
            });
        });
        $('body').on('click', '#deletePreliminaryOrganisationModal .confirm-delete-preliminary-org', function() {
            const id = $(this).data('id');
            if (id > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/admin/delete-team',
                    data: { organisation_id: id },
                    success: (response) => {
                        if (response.result) {
                            $('#deletePreliminaryOrganisationModal').modal('hide');
                            location.reload();
                        }
                    },
                    error: (response) => {
                        console.log(response);
                        
                    }
                });
            }
        });
    },

    copyLink(){
        $('body').on('click', '.copy-link-preliminary-org', function() {
            const link = $(this).data('link');
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(link);
            } else {
                const textArea = document.createElement("textarea");
                textArea.textContent = link;
                
                // Move textarea out of the viewport so it's not visible
                textArea.style.position = "absolute";
                textArea.style.left = "-999999px";
                
                
                document.body.prepend(textArea);
                textArea.select();

                try {
                    document.execCommand('copy');
                } catch (error) {
                    console.error(error);
                } finally {
                    textArea.remove();
                }
            }
        });
    },

    sendInviteEmail(){
        $('body').on('click', '.send-invite-email-preliminary-org', function() {
            const id = $(this).data('id');
            $.ajax({
                type: 'GET',
                url: '/admin/preliminary-organisations/'+id+'/send-invite',
                success: (response) => {
                    $('#form-container').html(response);
                    $('#sendInvitePreliminaryOrganisationModal').modal('show');
                }
            });
        });
        $('body').on('click', '#sendInvitePreliminaryOrganisationModal .confirm-send-invite-preliminary-org', function() {
            const id = $(this).data('id');
            if (id > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/admin/preliminary-organisations/'+id+'/send-invite',
                    data: { 
                        email: $('#sendInvitePreliminaryOrganisationModal #email').val(),
                        name: $('#sendInvitePreliminaryOrganisationModal #name').val()
                    },
                    beforeSend: () => {
                        $('#sendInvitePreliminaryOrganisationModal button.btn').prop('disabled', true);
                    },
                    success: (response) => {
                        if (response.success) {
                            $('#sendInvitePreliminaryOrganisationModal').modal('hide');
                        }
                    },
                    error: (response) => {
                        $('#sendInvitePreliminaryOrganisationModal button.btn').removeAttr('disabled');
                        if (response.responseJSON && response.responseJSON.errors) {
                            let errorMessages = [];
                            $.each(response.responseJSON.errors, function(field, messages) {
                                if (Array.isArray(messages)) {
                                    errorMessages = errorMessages.concat(messages);
                                } else {
                                    errorMessages.push(messages);
                                }
                            });
                            $('#invite-email-error').removeClass('d-none').html(errorMessages.join('<br>'));
                        } else if (response.responseJSON && response.responseJSON.message) {
                            $('#invite-email-error').removeClass('d-none').text(response.responseJSON.message);
                        }
                    }
                });
            }
        });
    },
}